import IframeContent from '../../../taskManagement/createLightbox/project/IframeContent'
import WelcomeScreenLightboxHeader from './WelcomeScreenLightboxHeader'
import WelcomeScreenLightboxFooter from './WelcomeScreenLightboxFooter'
import LightBox from '../../../components/LightBox'

export default class WelcomeScreenLightbox extends LightBox {

    constructor({
        onCloseCallback,
        iframeLoadCallback,
        frameName,
    }) {
        super()

        this.callbacks = {
            onCloseCallback,
            iframeLoadCallback,
        }

        this.params = {
            frameName,
        }
    }

    changeUrl(url) {
        this.content.setState({url})
    }

    changeSize(size) {
        this.content.setState({size})
        this.centrePopup()
    }

    lightBoxHideHandle() {}

    init() {
        const header = new WelcomeScreenLightboxHeader()
        const footer = new WelcomeScreenLightboxFooter()
        this.content = new IframeContent({
            iframeLoadCallback: this.callbacks.iframeLoadCallback,
            frameName: this.params.frameName,
        })

        super.init(
            {
                id: 'welcomeScreenLightbox',
                header,
                content: this.content,
                footer,
                classNames: 'externalContentLightbox',
                correctionOffset: 60,
                moireDivId: 'whiteMoireDiv',
                cancelCallback: this.callbacks.onCloseCallback,
            })
        return this
    }
}


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/components/WelcomeScreenLightbox.js